import React from 'react';
import { StoreTier, SlotStatus } from '../../data/types';
type BadgeVariant = StoreTier | SlotStatus | 'default';
interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}
const variantStyles: Record<BadgeVariant, string> = {
  flagship: 'bg-primary text-white',
  'high-traffic': 'bg-blocked text-white',
  standard: 'bg-surface-warm text-text-secondary border border-border',
  available: 'bg-available-bg text-available border border-available/20',
  booked: 'bg-booked/30 text-text-secondary',
  blocked: 'bg-blocked text-white',
  internal: 'bg-internal-bg text-internal border border-internal/20',
  removed: 'bg-removed-bg text-text-secondary border border-removed/20',
  default: 'bg-surface text-text-secondary'
};
export function Badge({
  variant = 'default',
  children,
  className = ''
}: BadgeProps) {
  return <span className={`
        inline-flex items-center
        px-2.5 py-0.5
        text-[11px] font-semibold
        tracking-wide
        rounded-md
        ${variantStyles[variant]}
        ${className}
      `} data-id="element-1043">
      {children}
    </span>;
}